import type {StateMachineEventDef, StateMachineErrorCallback} from 'javascript-state-machine';

import {HeartbeatPayload} from '../types/StateMachineCallbacks';
import {logger} from '../utils/Logger';

type OnReturn = {
  stayIn: (state: string) => StateMachineEventDef;
};

export function on(event: string): OnReturn {
  return {
    stayIn: (state: string) => ({name: event, from: state, to: state}),
  };
}

/**
 * By default, if you try to call an event method that is not allowed in the current state,
 * the state machine will throw an exception.
 * To handle this problem ourselves, we define a custom error handler that will log the error.
 *
 * @see https://github.com/jakesgordon/javascript-state-machine/blob/2.4.0/README.md#handling-failures
 */
export const customStateMachineErrorCallback: StateMachineErrorCallback = (
  _eventName,
  _from,
  _to,
  _args,
  _errorCode,
  errorMessage,
  _ex,
) => {
  logger.error('Error in StateMachine: ' + errorMessage);
};

/**
 *
 * @param duration duration of the heartbeat
 * @param state state of heartbeat
 * @returns payload containing the
 */
export const createHeartbeatPayload = (duration: number, state: Lowercase<string>): HeartbeatPayload => {
  let payload: HeartbeatPayload = {};
  switch (state) {
    case 'playing':
      payload = {played: duration};
      break;
    case 'buffering':
      payload = {buffered: duration};
      break;
    case 'paused':
      payload = {paused: duration};
      break;
    default:
      break;
  }
  return payload;
};
